.di{z-index:2;}